import React, {MouseEventHandler} from 'react';
import {Icons} from '../../icons/icons';
import {HibuButton} from '../../common/hibuButton/hibuButton';

export type ChatInputActionsProps = {
    handleReset: () => void;
    handleHelp: MouseEventHandler<HTMLButtonElement>;
};

export const ChatInputSettings = ({handleReset, handleHelp}: ChatInputActionsProps): React.JSX.Element => (
    <div className="chat-input-actions">
        <HibuButton
            visible
            size="sm"
            className="hibu-button-embedded-borders"
            icon={Icons.HELP_LIGHTBULB}
            onClick={handleHelp}
            tooltipKey="search.details.hibu-assistant.help"
            placement="top"
        />
        <span className="chat-input-action-separator" aria-hidden="true"/>
        <HibuButton
            visible
            size="sm"
            className="hibu-button-embedded-borders"
            icon={Icons.CLEAR_BROOM}
            onClick={handleReset}
            tooltipKey="search.details.hibu-assistant.delete"
            placement="top"
        />
    </div>
);
